@if(scanService.enabled()){
	<div class="background">
		<div class="scan-container" [loading]="loading()">
			<div class="back-container mt-4">
				<button (click)="scanService.disable()" class="text-primary">
					<i class="fa-solid fa-arrow-left"></i> Retour
				</button>
			</div>
			<div class="actions-container" [ngClass]="{'congrat-bg': success()}">
				<div>
					@if(!success()){
						@switch(scanService.type()){
							@case('binder'){
								<p class="title-xs font-serra">Ajoute des cartes dans ton binder</p>
								<p class="subtitle">Scanne une page de ton binder pour ajouter automatiquement des cartes.</p>
								@if(error()){
									<div class="back-container py-4 px-4">
										<lgb-message [(error)]="error"></lgb-message>
									</div>
								}
								<img class="animation" src="img/skin/scan-tcg.svg"/>
								<div class="action-container">
									<label for="input-page" class="btn bg-white text-primary border-[#e5e5e5] mb-2">
										<i class="fa-regular fa-grid-2-plus"></i> Scanner une page
									</label>
									<input id="input-page" (change)="scanPage($event)" class="img-none" type="file" accept="image/*" />
								</div>
							}
							@case('page'){
								<p class="title-xs font-serra">Modifie les cartes de cette page</p>
								<p class="subtitle">Besoin de changements ? Rescane la page ou ajoute des cartes.</p>
								@if(error()){
									<div class="back-container py-4 px-4">
										<lgb-message [(error)]="error"></lgb-message>
									</div>
								}
								<img class="animation" src="img/skin/scan-tcg.svg"/>
								<div class="action-container">
									<label for="input-page" class="btn bg-white text-primary border-[#e5e5e5] mb-2">
										<i class="fa-regular fa-grid-2-plus"></i> Rescanner la page
									</label>
									<label for="input-card" class="btn bg-white text-primary border-[#e5e5e5] mb-2">
										<i class="fa-regular fa-cards-blank"></i> Scanner une carte
									</label>
									<a (click)="rmPage()" class="btn bg-white text-error border-[#e5e5e5] mb-2">
										<i class="fa-regular fa-regular fa-trash"></i> Supprimer la page
									</a>
									<input id="input-page" (change)="refreshPage($event)" class="img-none" type="file" accept="image/*" />
									<input id="input-card" (change)="scanCard($event)" class="img-none" type="file" accept="image/*" />
								</div>
							}
							@case('card'){
								<p class="title-xs font-serra">Nouveau scan, meilleur résultat</p>
								<p class="subtitle">Rescane la carte si la carte trouvée n’est pas la bonne, ou pour obtenir une image plus propre et plus nette.</p>
								@if(error()){
									<div class="back-container py-4 px-4">
										<lgb-message [(error)]="error"></lgb-message>
									</div>
								}
								<img class="animation" src="img/skin/scan-tcg.svg"/>
								<div class="action-container">
									<label for="input-page" class="btn bg-white text-primary border-[#e5e5e5] mb-2">
										<i class="fa-regular fa-cards-blank"></i> Rescanner la carte
									</label>
									<input id="input-page" (change)="refreshCard($event)" class="img-none" type="file" accept="image/*" />
								</div>
							}
						}
					}
					@else{
						<p class="title-xs font-serra">Félicitations !</p>
						<div class="title-congrat subtitle">
							Scan ajouté à votre binder. Les cartes apparaîtront une fois l’analyse terminée.
						</div>
						<div class="action-container">
							@if(scanService.type()!='card'){
								<button (click)="success.set(false)" class="btn bg-white text-primary border-[#e5e5e5] mb-2">{{((scanService.type()=='binder')? 'Ajouter une autre page' : 'Ajouter une autre scan')}}</button>
							}
							<button (click)="back()" class="btn bg-white text-primary border-[#e5e5e5] mb-2">Retour</button>
						</div>
					}
				</div>
			</div>
		</div>
	</div>
}